var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0002,
    cy: 20.0007,
    r: 15,
    stroke: "#E9E9E9",
    strokeWidth: 3.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3335 20.0007H36.6668C36.6668 21.1264 36.5528 22.2428 36.3301 23.334C35.8564 25.6544 34.8909 27.8603 33.4838 29.7971C31.415 32.6445 28.4978 34.764 25.1504 35.8516C21.8031 36.9392 18.1973 36.9392 14.8499 35.8516C11.5025 34.764 8.58535 32.6445 6.51655 29.7971C4.44774 26.9496 3.3335 23.5203 3.3335 20.0006C3.3335 16.481 4.44775 13.0517 6.51655 10.2042C8.58535 7.35677 11.5025 5.23734 14.8499 4.14971C17.1267 3.40994 19.523 3.17334 21.8762 3.43989C22.9818 3.56513 24.0778 3.80141 25.1475 4.14875L25.1504 4.14971L24.1215 7.3165C22.8804 6.91353 21.5595 6.68764 20.1886 6.66865C20.063 6.66687 19.9373 6.66687 19.8117 6.66865C16.3347 6.71682 13.1793 8.09592 10.8321 10.3195C10.6537 10.4884 10.4799 10.6624 10.3108 10.8413C8.05193 13.23 6.66683 16.4536 6.66683 20.0007C6.66683 27.3645 12.6364 33.334 20.0002 33.334C27.364 33.334 33.3335 27.3645 33.3335 20.0007C33.3335 20.0007 33.3335 20.0007 33.3335 20.0007Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.e3fd4ebb56aa4bfa8e294c5f1af226c1.svg";
export { ForwardRef as ReactComponent };